import { useEffect, useState } from "react";
import { useAppContext } from "hooks/app";
import { Modals } from "constants/modals";
import ModalLayout from "components/ModalLayout/ModalLayout";
import { useLocation } from "react-router-dom";
import { useLogout, useUser } from "hooks/user";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import PhoneVerification from "./PhoneVerification/PhoneVerification";
import { isValidPhoneNumber } from "react-phone-number-input";
import { usePhoneVerify } from "hooks/user";
import toast from "react-hot-toast";
import { WHATSAPP_LINK } from "constants/routes";
import { useSiteSettingsByKey } from "hooks/settings";
import { Spinner } from "@chakra-ui/react";

export const BarePhoneVerificationComponent = () => {
  const { openModal, closeModal } = useAppContext();
  const { logout } = useLogout();

  const [showOtp, setShowOtp] = useState(false);
  const { pathname } = useLocation();
  const { user, isLoading } = useUser();
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isPhoneValid, setIsPhoneValid] = useState(true);
  const { sendWhatsappOtp, validateWhatsappOtp } = usePhoneVerify();
  const { data: whatsappNumber } = useSiteSettingsByKey({ key: "whatsapp-number" })
  // Admin toggle (Website Settings). Unset means ON, matching the backend default.
  const { data: otpSetting, isLoading: isLoadingOtpSetting } = useSiteSettingsByKey({ key: "WHATSAPP_OTP_VERIFICATION" })
  const otpEnabled = otpSetting?.[0]?.settingValue?.trim().toUpperCase() !== "OFF"
  const [isRequestLoading, setIsRequestLoading] = useState(false)
  useEffect(() => {
    if (isLoading) return;
    if (!user?.phoneNumber && pathname.includes("user")) {
      openModal?.(Modals.PHONE_POPUP);
    }
  }, [user]);

  const handleSendOtp = async () => {
    setIsPhoneValid(isValidPhoneNumber(phoneNumber));

    if (!isValidPhoneNumber(phoneNumber)) return;
    setIsRequestLoading(true)
    // Stays true when the number is saved: the step is swapped out once the
    // cached user updates, so the button must not flash back to enabled.
    let advanced = false
    try {
      // OTP off — no verification, just save the number and move to the next step.
      // The send endpoint also reports otpRequired: false in case this setting is stale.
      const data = otpEnabled
        ? await sendWhatsappOtp({ id: user?.id, phone: phoneNumber })
        : { success: true, otpRequired: false };
      if (!data.success) {
        toast.error(data.message)
      } else if (data.otpRequired === false) {
        // OTP verification is off — save the number without a code.
        const result = await validateWhatsappOtp({ phone: phoneNumber });
        if (result?.status === "success") {
          advanced = true
          closeModal?.();
        }
      } else {
        setShowOtp(true);
      }
    } catch (err) {
    } finally {
      if (!advanced) setIsRequestLoading(false)
    }
  };

  const handleNumberChange = (number: string) => {
    isValidPhoneNumber(number) && setIsPhoneValid(true);

    setPhoneNumber(number);
  };

  // Wait for the OTP setting so the copy doesn't switch between
  // "Verify" and "Add" after first paint.
  if (isLoadingOtpSetting) return (
    <div className="min-h-[400px] flex items-center justify-center">
      <Spinner size="lg" color="#185ADB" />
    </div>
  )

  return (
    <div className="min-h-[400px] flex flex-col justify-between">
      <div className="flex flex-col items-start justify-start gap-4">
        <p>You're logged in with <b>{user?.email}</b></p>
        {!showOtp ? (
          <>
            <div>
              <h3 className="text-xl font-bold">{otpEnabled ? "Verify your WhatsApp" : "Add your WhatsApp"}</h3>
              <p>{otpEnabled ? "Insert WhatsApp number to verify" : "Insert your WhatsApp number to continue"}</p>
            </div>
            <div className="flex">
              <PhoneInput
                defaultCountry="pk"
                value={phoneNumber}
                onChange={(phoneNumber) => handleNumberChange(phoneNumber)}
                disabled={isRequestLoading}
                style={isPhoneValid ? {
                } : { border: "1px solid red", borderRadius: '5px' }}
                inputStyle={{
                }}
              />
              {!isPhoneValid && (
                <p style={{ color: "red", fontSize: '12px' }}>Enter a valid number</p>
              )}
            </div>
              
            <button
              className="btnPrimary inline-flex items-center justify-center gap-2 disabled:opacity-60 disabled:cursor-not-allowed"
              disabled={isRequestLoading}
              onClick={handleSendOtp}
            >
              {isRequestLoading && <Spinner size="sm" />}
              {isRequestLoading
                ? (otpEnabled ? "Sending code..." : "Saving...")
                : (otpEnabled ? "Verify Now" : "Continue")}
            </button>
          </>
        ) : (
          <PhoneVerification
            onBack={() => setShowOtp(false)}
            phone={phoneNumber}
          />
        )}
        <div>
          {otpEnabled && whatsappNumber?.length > 0 && <p>Didn't receive OTP? Contact to our Support team via WhatsApp <a className="text-primary" href={`${WHATSAPP_LINK+whatsappNumber[0].settingValue}`} target="_blank">{whatsappNumber[0].settingValue}</a> </p>}
        </div>
      </div>
      <button onClick={() => logout().catch()} className="btn btnSecondary">Logout</button>
      </div>
  )
}

const PhonePopup = () => {
  

  return (
    <ModalLayout modal={Modals.PHONE_POPUP}>
      <BarePhoneVerificationComponent />    
    </ModalLayout>
  );
};
export default PhonePopup;
